import axiosInstance from './api';
import TokenService from './token.service';

const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken();
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      // Must exempt BOTH the login endpoint (/identity/v1/auth) AND the
      // refresh endpoint itself (/identity/v1/auth/refresh, called below) -
      // otherwise a failed refresh (401, e.g. a genuinely expired refresh
      // token) re-enters this same retry branch on ITS OWN response and
      // keeps re-attempting the refresh forever. Same bug found and fixed
      // in web-staging's copy of this file 2026-09-10 (confirmed live:
      // 1,100+ refresh attempts in ~6 seconds on a stale session, pegging
      // a page on an infinite loading spinner and hammering identity-svc).
      if (
        originalConfig.url !== '/identity/v1/auth' &&
        originalConfig.url !== '/identity/v1/auth/refresh' &&
        err.response
      ) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;

          try {
            const rs = await axiosInstance.post('/identity/v1/auth/refresh', {
              refresh_token: TokenService.getLocalRefreshToken(),
            });
            const new_token = rs.data;

            store.dispatch('auth/refreshToken', new_token);

            TokenService.updateLocalToken(new_token);

            return axiosInstance(originalConfig);
          } catch (_error) {
            store.dispatch('auth/logout');
            return Promise.reject(_error);
          }
        }
      }

      return Promise.reject(err);
    }
  );
};

export default setup;
